import React, { useState } from "react";
import BackBtn from "../../common/backBTN";

function Mission({ turnovers = [], transactionAmount = 0, userData = {} }) {
  const [activeTab, setActiveTab] = useState("active");
  const [openDetailId, setOpenDetailId] = useState(null);

  // === Helpers ===
  const getProgressPercent = (current, target) => {
    const c = parseFloat(current) || 0;
    const t = parseFloat(target) || 1;
    const percent = (c / t) * 100;
    return percent > 100 ? 100 : percent.toFixed(0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "00-00-00";
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    return new Date(dateString).toLocaleString("en-US", options);
  };

  const formatAmount = (value) => {
    const amount = Number(value);
    return Number.isFinite(amount) ? amount.toFixed(2) : "0.00";
  };

  const copyToClipboard = (text, label = "Text") => {
    try {
      const value = text ?? "";
      if (!value) return;
      if (navigator?.clipboard?.writeText) {
        navigator.clipboard.writeText(String(value));
        alert(`${label} copied!`);
      } else {
        const ta = document.createElement("textarea");
        ta.value = String(value);
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        alert(`${label} copied!`);
      }
    } catch (e) {
      console.error("Copy failed", e);
    }
  };

  const filterTurnovers = (status) => {
    if (status === "active") return turnovers.filter((t) => t.status === "active");
    if (status === "complete") return turnovers.filter((t) => t.status === "complete");
    return [];
  };

  const getStatusLabel = (status) => {
    if (status === "active") return "Active";
    if (status === "complete") return "Completed";
    return "Active";
  };

  const tabList = [
    { key: "active", label: "Active" },
    { key: "complete", label: "Completed" },
  ];

  const currentList = filterTurnovers(activeTab);
  const remoteId = userData?.remote_id || localStorage.getItem("remote_id") || "";

  return (
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
      <div>
        {/* ==== Header ==== */}
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-leaderBoard mc-default-header am-navbar am-navbar-light"
          >
            <BackBtn />
            <div className="am-navbar-title">Turnover</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>

        {/* ==== Profile ==== */}
        <div className="leader-board-container leader-board-root">
          <div className="leader-board-header">
            <div className="profile-icon">
              <img
                src="https://images.384894992.com//TCG_PROD_IMAGES/B2C/01_PROFILE/PROFILE/0.png"
                alt="profile"
              />
            </div>

            <div className="leader-board-header-info">
              <div className="leader-board-title">
                <span
                  className="name-text"
                  style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
                >
                  {userData?.username || "Guest"}
                  <span
                    role="button"
                    aria-label="Copy username"
                    onClick={() => copyToClipboard(userData?.username || "", "Username")}
                    style={{ cursor: "pointer", display: "inline-flex" }}
                  >
                    <svg className="am-icon am-icon-icon-copy_17d4102f am-icon-md">
                      <use xlinkHref="#icon-copy_17d4102f" />
                    </svg>
                  </span>
                </span>
                <span
                  className="name-text"
                  style={{ marginLeft: 8, fontSize: "0.28rem", display: "inline-flex", alignItems: "center", gap: 6 }}
                >
                  ID: {remoteId || "-"}
                  <span
                    role="button"
                    aria-label="Copy remote id"
                    onClick={() => copyToClipboard(remoteId, "Remote ID")}
                    style={{ cursor: "pointer", display: "inline-flex" }}
                  >
                    <svg className="am-icon am-icon-icon-copy_17d4102f am-icon-md">
                      <use xlinkHref="#icon-copy_17d4102f" />
                    </svg>
                  </span>
                </span>
              </div>
              <div className="leader-board-balance">
                <div>৳ {formatAmount(userData?.balance)}</div>
              </div>
            </div>
          </div>

          {/* ==== Tabs ==== */}
          <div className="am-tabs am-tabs-top">
            <div role="tablist" className="am-tabs-bar" tabIndex={0}>
              {tabList.map((tab) => (
                <div
                  key={tab.key}
                  role="tab"
                  aria-disabled="false"
                  aria-selected={activeTab === tab.key}
                  className={`am-tabs-tab ${
                    activeTab === tab.key ? "am-tabs-tab-active" : ""
                  }`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  <span className="am-badge">{tab.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* ==== Mission List ==== */}
          <div className="leader-board-list-content">
            <div
              className="list-wrapper"
              style={{ height: "calc(100 * var(--vh, 1vh) - 203px)" }}
            >
              <ul className="scroll-inner-container">
                {currentList.length === 0 ? (
                  <div
                    style={{
                      textAlign: "center",
                      color: "#999",
                      padding: "1rem",
                      fontSize: "0.32rem",
                    }}
                  >
                    {activeTab === "active"
                      ? "No active turnover"
                      : "No completed turnover"}
                  </div>
                ) : (
                  currentList.map((item, idx) => {
                    const requiredTurnover = parseFloat(item.required_turnover) || 0;
                    const progress =
                      item.status === "complete"
                        ? 100
                        : getProgressPercent(transactionAmount, requiredTurnover);
                    const currentAmount =
                      item.status === "complete" ? requiredTurnover : transactionAmount;
                    const statusLabel = getStatusLabel(item.status);
                    const itemId = item.id ?? idx;
                    const isDetailsOpen = openDetailId === itemId;

                    return (
                      <li key={idx}>
                        <div className="leader-board-container">
                          <div className="leader-board-content">
                            <div className="O leader-board-list">
                              <div className="leader-board-card level-01">
                                <div className="leader-border-card-icon">
                                  <img
                                    src="/icons/reward/icon-level.svg"
                                    alt="level"
                                  />
                                </div>
                                <div className="lb-card-title">
                                  {item.transaction?.action === 'bonus'
                                            ? item.transaction?.promotion?.name
                                            : 'Regular Deposit'}
                                </div>
                                <div className="lb-card-info">
                                  Date: <span>{item.created_at
                                      ? new Date(item.created_at).toISOString().slice(0, 10)
                                      : "00-00-00"}</span>
                                </div>
                                <div className="lb-card-info time-left">
                                  {item.status === "complete" ? "Completed:" : "Start Date:"}{" "}
                                  <span>
                                    {item.status === "complete"
                                      ? formatDate(item.updated_at)
                                      : item.created_at
                                      ? new Date(item.created_at).toISOString().slice(0, 10)
                                      : "00-00-00"}
                                  </span>
                                </div>
                                <div className="lb-card-info">
                                  Milestones：
                                  <span>
                                    {currentAmount || 0}/{requiredTurnover || 0}
                                  </span>
                                </div>
                                <div className="lb-percent-text">
                                  {progress}
                                  <span>%</span>
                                </div>
                                <div className="lb-card-operating">
                                  <div />
                                  <button
                                    type="button"
                                    className="lb-rule"
                                    onClick={() =>
                                      setOpenDetailId(isDetailsOpen ? null : itemId)
                                    }
                                  >
                                    Details
                                  </button>
                                </div>
                                {isDetailsOpen && (
                                  <div className="lb-card-info">
                                    <div>Status: {statusLabel}</div>
                                    <div>Required: {requiredTurnover || 0}</div>
                                    <div>Current: {currentAmount || 0}</div>
                                    {item.status === "complete" && (
                                      <div>Completed: {formatDate(item.updated_at)}</div>
                                    )}
                                  </div>
                                )}
                                <div className="lb-card-info lb-progress">
                                  <div
                                    className="lb-processing-percent"
                                    style={{ width: `${progress}%` }}
                                  />
                                </div>
                              </div>

                              {/* === Milestone Info === */}
                              {/* <div className="lb-milestone">
                                <div className="lmi-title fire-icon">
                                  <img src="https://www.yesb1.com/mobile/mc/fire_c.2961cee0.png" alt="fire" />
                                  Milestones ({item.total_milestone || 0})
                                </div>
                                <div className="lmi-info-card">
                                  <div className="lmi-info-card-running">
                                    <svg className="am-icon am-icon-running_41c9243e am-icon-md">
                                      <use xlinkHref="#running_41c9243e" />
                                    </svg>
                                  </div>
                                  <div className="lmi-info-card-container">
                                    <div className="lic-header">
                                      <div className="lic-header-list">
                                        <div>Valid bet:</div>
                                        <div>
                                          ৳ {item.valid_bet || 0}/{item.target_amount || 0}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="lic-footer">
                                      <div className="lb-ticket-item bonus">
                                        <span>
                                          <svg className="am-icon am-icon-bonus_59423f12 am-icon-md">
                                            <use xlinkHref="#bonus_59423f12" />
                                          </svg>
                                        </span>
                                        Bonus&nbsp;:<i>৳ {item.bonus_amount || 0}</i>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="mission-status"
                                  style={{
                                    marginTop: "10px",
                                    color:
                                      item.status === "active"
                                        ? "#ffb400"
                                        : item.status === "complete"
                                        ? "#1cc88a"
                                        : "#999",
                                    fontWeight: 600,
                                  }}
                                >
                                  {statusLabel}
                                </div>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })
                )}
              </ul>
              <div className="pullup-wrapper" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mission;
